import { useQuery } from "@tanstack/react-query";
import { apiService } from "../services/api";
import { AppSettings } from "../types";

export function useAppSettings() {
  return useQuery<AppSettings>({
    queryKey: ["appSettings"],
    queryFn: async () => {
      return await apiService.getAppSettings();
    },
    staleTime: 0, // Данные считаются устаревшими сразу, чтобы всегда обновлялись
    refetchInterval: 30000, // Обновление каждые 30 секунд
    refetchOnWindowFocus: true, // Обновление при возврате фокуса на окно
    refetchOnMount: true, // Обновление при монтировании компонента
    retry: 1, // Повторная попытка при ошибке
  });
}

